<app-main-layout>
    <div class="py-5 px-4">
        <div class="font-bold text-2xl">
            <h1>Settings</h1>
        </div>
   

        <mat-tab-group>
            <mat-tab label="Company Settings">
                <div class="py-4">
                    <div class="mt-4 mat-elevation-z8 p-5">
                        <form [formGroup]="companySettingsForm" (ngSubmit)="onSubmit()">
            
                            <!-- Comapany Name -->
                            <div>
                                <label class="font-semibold">Company Name:*</label>
                                <div class="mt-2">
                                <input
                                    class="p-2 rounded shodow-sm bg-slate-100 w-full"
                                    name="comapany-name"
                                    type="text"
                                    placeholder="Enter company name"
                                    formControlName="companyName"
                                />
                                </div>
                            </div>
                            <!-- Comapany Name -->
                            <!-- Comapany Address -->
                             <div>
                                <label class="font-semibold">Company Address:*</label>
                                <div class="mt-2" >
                                    <textarea rows="6"
                                    class="p-2 rounded shodow-sm bg-nu-grey w-full"
                                    name="company-address"
                                    placeholder="Enter company address"
                                    formControlName="companyAddress"
                                  ></textarea>
                                </div>
                              
                            </div>
                            <!-- Comapany Address -->
                            <!-- Comapany GST No -->
                            <div>
                                <label class="font-semibold">GST No:*</label>
                                <div class="mt-2">
                                <input
                                    class="p-2 rounded shodow-sm bg-slate-100 w-full"
                                    name="gst-no"
                                    type="text"
                                    placeholder="Enter GST No"
                                    formControlName="gstNo"
                                />
                                </div>
                            </div>
                            <!-- Comapany GST No -->
            
                            <!-- Currency -->
                            <div class="mt-4">
                                <label class="font-semibold">Currency:*</label>
                                <div class="mt-2">
                                <select
                                    class="p-2 rounded shodow-sm bg-slate-100 w-full"
                                    name="comapany-currency"
                                    type="text"
                                    placeholder="Select the currency"
                                    formControlName="currency"
                                >
                                <option value="GBP" aria-checked="true">GBP - British Pound Sterling</option>
                                <option value="AED">AED - United Arab Emirates Dirham</option>
                                <option value="AFN">AFN - Afghan Afghani</option>
                                <option value="ALL">ALL - Albanian Lek</option>
                                <option value="AMD">AMD - Armenian Dram</option>
                                <option value="ANG">ANG - Netherlands Antillean Guilder</option>
                                <option value="AOA">AOA - Angolan Kwanza</option>
                                <option value="ARS">ARS - Argentine Peso</option>
                                <option value="AUD">AUD - Australian Dollar</option>
                                <option value="AWG">AWG - Aruban Florin</option>
                                <option value="AZN">AZN - Azerbaijani Manat</option>
                                <option value="BAM">BAM - Bosnia-Herzegovina Convertible Mark</option>
                                <option value="BBD">BBD - Barbadian Dollar</option>
                                <option value="BDT">BDT - Bangladeshi Taka</option>
                                <option value="BGN">BGN - Bulgarian Lev</option>
                                <option value="BHD">BHD - Bahraini Dinar</option>
                                <option value="BIF">BIF - Burundian Franc</option>
                                <option value="BMD">BMD - Bermudian Dollar</option>
                                <option value="BND">BND - Brunei Dollar</option>
                                <option value="BOB">BOB - Bolivian Boliviano</option>
                                <option value="BRL">BRL - Brazilian Real</option>
                                <option value="BSD">BSD - Bahamian Dollar</option>
                                <option value="BTN">BTN - Bhutanese Ngultrum</option>
                                <option value="BWP">BWP - Botswanan Pula</option>
                                <option value="BYN">BYN - Belarusian Ruble</option>
                                <option value="BZD">BZD - Belize Dollar</option>
                                <option value="CAD">CAD - Canadian Dollar</option>
                                <option value="CDF">CDF - Congolese Franc</option>
                                <option value="CHF">CHF - Swiss Franc</option>
                                <option value="CLP">CLP - Chilean Peso</option>
                                <option value="CNY">CNY - Chinese Yuan</option>
                                <option value="COP">COP - Colombian Peso</option>
                                <option value="CRC">CRC - Costa Rican Colón</option>
                                <option value="CUP">CUP - Cuban Peso</option>
                                <option value="CVE">CVE - Cape Verdean Escudo</option>
                                <option value="CZK">CZK - Czech Koruna</option>
                                <option value="DJF">DJF - Djiboutian Franc</option>
                                <option value="DKK">DKK - Danish Krone</option>
                                <option value="DOP">DOP - Dominican Peso</option>
                                <option value="DZD">DZD - Algerian Dinar</option>
                                <option value="EGP">EGP - Egyptian Pound</option>
                                <option value="ERN">ERN - Eritrean Nakfa</option>
                                <option value="ETB">ETB - Ethiopian Birr</option>
                                <option value="EUR">EUR - Euro</option>
                                <option value="FJD">FJD - Fijian Dollar</option>
                                <option value="FKP">FKP - Falkland Islands Pound</option>
                                <option value="FOK">FOK - Faroese Króna</option>
                                <option value="GEL">GEL - Georgian Lari</option>
                                <option value="GGP">GGP - Guernsey Pound</option>
                                <option value="GHS">GHS - Ghanaian Cedi</option>
                                <option value="GIP">GIP - Gibraltar Pound</option>
                                <option value="GMD">GMD - Gambian Dalasi</option>
                                <option value="GNF">GNF - Guinean Franc</option>
                                <option value="GTQ">GTQ - Guatemalan Quetzal</option>
                                <option value="GYD">GYD - Guyanaese Dollar</option>
                                <option value="HKD">HKD - Hong Kong Dollar</option>
                                <option value="HNL">HNL - Honduran Lempira</option>
                                <option value="HRK">HRK - Croatian Kuna</option>
                                <option value="HTG">HTG - Haitian Gourde</option>
                                <option value="HUF">HUF - Hungarian Forint</option>
                                <option value="IDR">IDR - Indonesian Rupiah</option>
                                <option value="ILS">ILS - Israeli New Shekel</option>
                                <option value="IMP">IMP - Isle of Man Pound</option>
                                <option value="INR">INR - Indian Rupee</option>
                                <option value="IQD">IQD - Iraqi Dinar</option>
                                <option value="IRR">IRR - Iranian Rial</option>
                                <option value="ISK">ISK - Icelandic Króna</option>
                                <option value="JEP">JEP - Jersey Pound</option>
                                <option value="JMD">JMD - Jamaican Dollar</option>
                                <option value="JOD">JOD - Jordanian Dinar</option>
                                <option value="JPY">JPY - Japanese Yen</option>
                                <option value="KES">KES - Kenyan Shilling</option>
                                <option value="KGS">KGS - Kyrgystani Som</option>
                                <option value="KHR">KHR - Cambodian Riel</option>
                                <option value="KID">KID - Kiribati Dollar</option>
                                </select>
                                </div>
                            </div>
                            <!-- Currency -->
            
                            <!-- Email enabled -->
                            <div class="mt-4">
                                <label class="font-semibold">Email Enabled:*</label>
                                <div class="mt-2">
                                <input
                                    name="comapany-emails-enabled"
                                    type="checkbox"
                                    formControlName="emailEnable"
                                />
                                </div>
                            </div>
                            <!-- Email enabled -->

                            <!-- Admin Emails -->
                            <div>
                                <label class="font-semibold">Admin emails:*</label> <br />
                                <label class="text-xs text-neutral-500">Please add emails followed by ',' without any space. Example: {{'email@mailing.com,emailtwo@mailing.com'}}</label>
                                <div class="mt-2">
                                <input
                                    class="p-2 rounded shodow-sm bg-slate-100 w-full"
                                    name="admin-emails"
                                    type="text"
                                    placeholder="Enter Admin emails"
                                    formControlName="adminEmails"
                                />
                                </div>
                            </div>
                            <!-- Admin Emails -->

                             <!-- Support Emails -->
                            <div>
                                <label class="font-semibold">Support emails:*</label> <br />
                                <label class="text-xs text-neutral-500">Please add emails followed by ',' without any space. Example: {{'email@mailing.com,emailtwo@mailing.com'}}</label>
                                <div class="mt-2">
                                <input
                                    class="p-2 rounded shodow-sm bg-slate-100 w-full"
                                    name="support-emails"
                                    type="text"
                                    placeholder="Enter support emails"
                                    formControlName="supportEmail"
                                />
                                </div>
                            </div>
                            <!-- Support Emails -->

                            <!-- Sales Emails -->
                            <div>
                                <label class="font-semibold">Sales emails:*</label> <br />
                                <label class="text-xs text-neutral-500">Please add emails followed by ',' without any space. Example: {{'email@mailing.com,emailtwo@mailing.com'}}</label>
                                <div class="mt-2">
                                <input
                                    class="p-2 rounded shodow-sm bg-slate-100 w-full"
                                    name="sales-emails"
                                    type="text"
                                    placeholder="Enter sales emails"
                                    formControlName="salesEmail"
                                />
                                </div>
                            </div>
                            <!-- Sales Emails -->

                            <!-- Affiliate Emails -->
                            <div>
                                <label class="font-semibold">Affiliate emails:*</label> <br />
                                <label class="text-xs text-neutral-500">Please add emails followed by ',' without any space. Example: {{'email@mailing.com,emailtwo@mailing.com'}}</label>
                                <div class="mt-2">
                                <input
                                    class="p-2 rounded shodow-sm bg-slate-100 w-full"
                                    name="affiliate-emails"
                                    type="text"
                                    placeholder="Enter affiliate emails"
                                    formControlName="affiliateEmail"
                                />
                                </div>
                            </div>
                            <!-- Affiliate Emails -->
                            <!-- Low stock alert Emails -->
                            <div>
                                <label class="font-semibold">Low stock alert emails:*</label> <br />
                                <label class="text-xs text-neutral-500">Please add emails followed by ',' without any space. Example: {{'email@mailing.com,emailtwo@mailing.com'}}</label>
                                <div class="mt-2">
                                <input
                                    class="p-2 rounded shodow-sm bg-slate-100 w-full"
                                    name="low-stock-alert-emails"
                                    type="text"
                                    placeholder="Enter low stock alert emails"
                                    formControlName="lowStockAlertEmail"
                                />
                                </div>
                            </div>
                            <!-- Low stock alert Emails -->
                            <!-- Out of stock alert Emails -->
                            <div>
                                <label class="font-semibold">Out of stock alert emails:*</label> <br />
                                <label class="text-xs text-neutral-500">Please add emails followed by ',' without any space. Example: {{'email@mailing.com,emailtwo@mailing.com'}}</label>
                                <div class="mt-2">
                                <input
                                    class="p-2 rounded shodow-sm bg-slate-100 w-full"
                                    name="out-of-stock-alert-emails"
                                    type="text"
                                    placeholder="Enter out of stock alert emails"
                                    formControlName="outOfStockEmail"
                                />
                                </div>
                            </div>
                            <!-- Out of stock alert Emails -->
                            <!-- Product Subscription alert Emails -->
                            <div>
                                <label class="font-semibold">Product Subscription alert emails:*</label> <br />
                                <label class="text-xs text-neutral-500">Please add emails followed by ',' without any space. Example: {{'email@mailing.com,emailtwo@mailing.com'}}</label>
                                <div class="mt-2">
                                <input
                                    class="p-2 rounded shodow-sm bg-slate-100 w-full"
                                    name="product-subscription-alert-emails"
                                    type="text"
                                    placeholder="Enter product subscription alert emails"
                                    formControlName="prodSubscribeEmail"
                                />
                                </div>
                            </div>
                            <!-- Out of stock alert Emails -->
            
                            <div class="mt-4">
                                <button
                                mat-button
                                mat-raised-button
                                color="primary"
                                cdkFocusInitial
                                type="submit"
                                >
                                Update
                                </button>
                            </div>
            
                        </form>
                    </div>
                </div>
            </mat-tab>
           
            <mat-tab label="Home Page Paving Menu">
                <div >
                    <div class="example-container">
                        <h2>All Categories</h2>
                      
                        <div
                          cdkDropList
                          #allPavCat="cdkDropList"
                          [cdkDropListData]="unselPavCategories"
                          [cdkDropListConnectedTo]="[selectedPavCat]"
                          class="example-list"
                          (cdkDropListDropped)="drop($event)">
                          @for (cat of unselPavCategories; track cat) {
                            <div class="example-box" cdkDrag>{{cat.name}}</div>
                          }
                        </div>
                    </div>
                      
                    <div class="example-container">
                        <h2>Paving Menu</h2>
                      
                        <div
                          cdkDropList
                          #selectedPavCat="cdkDropList"
                          [cdkDropListData]="pavingCats"
                          [cdkDropListConnectedTo]="[allPavCat]"
                          class="example-list"
                          (cdkDropListDropped)="drop($event)">
                          @for (cat of pavingCats; track cat) {
                            <div class="example-box" cdkDrag>{{cat.name}}</div>
                          }
                        </div>
                    </div>
                
                </div>
                <div class="mt-4">
                    <button
                    mat-button
                    mat-raised-button
                    color="primary"
                    cdkFocusInitial
                    (click) ="update(1)"
                    >
                    Update
                    </button>
                </div>

            </mat-tab>

            <mat-tab label="Home Page Category List">
                <div >
                    <div class="example-container">
                        <h2>All Categories</h2>
                      
                        <div
                          cdkDropList
                          #allHomeCat="cdkDropList"
                          [cdkDropListData]="unselHomeCategories"
                          [cdkDropListConnectedTo]="[selectedHomeCat]"
                          class="example-list"
                          (cdkDropListDropped)="drop($event)">
                          @for (cat of unselHomeCategories; track cat) {
                            <div class="example-box" cdkDrag>{{cat.name}}</div>
                          }
                        </div>
                    </div>
                      
                    <div class="example-container">
                        <h2>Home Page Categories</h2>
                      
                        <div
                          cdkDropList
                          #selectedHomeCat="cdkDropList"
                          [cdkDropListData]="homeCats"
                          [cdkDropListConnectedTo]="[allHomeCat]"
                          class="example-list"
                          (cdkDropListDropped)="drop($event)">
                          @for (cat of homeCats; track cat) {
                            <div class="example-box" cdkDrag>{{cat.name}}</div>
                          }
                        </div>
                    </div>
                
                </div>
                <div class="mt-4">
                    <button
                    mat-button
                    mat-raised-button
                    color="primary"
                    cdkFocusInitial
                    (click) ="update(2)"
                    >
                    Update
                    </button>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</app-main-layout>